export default __webpack_public_path__ + "static/cafe_partes_03-3b57674e10c731a03d5d63ac918797e7.png";